import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { injectIntl, useIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import enumCache from '@/shared/services/EnumCacheService';
import { crmTypeSorter } from '@/shared/utils/sorters';

class CrmTypeButtonGroup extends Component {
  state = {
    crmTypes: [],
  };

  componentDidMount() {
    const { intl, hiddenTypes } = this.props;
    enumCache.getTranslated('crmtype', intl, crmTypeSorter).then(crmTypes => {
      this.setState({
        crmTypes: crmTypes.filter(item => hiddenTypes.indexOf(item.id) < 0),
      });
    });
  }

  toggleRelationType = relType => {
    const { selectedTypes, onChange } = this.props;

    const idx = selectedTypes ? selectedTypes.indexOf(relType) : -1;
    if (idx >= 0) {
      onChange(selectedTypes.filter((_, i) => i !== idx));
    } else {
      onChange([...(selectedTypes || []), relType]);
    }
  };

  render() {
    const { crmTypes } = this.state;
    const { selectedTypes } = this.props;

    return (
      <div role="group" aria-label="crmType" className="btn-group btn-group-justified">
        {crmTypes &&
          crmTypes.map(t => (
            <button
              key={`CrmTypeFilter${t.id}`}
              onClick={() => {
                document.activeElement.blur();
                this.toggleRelationType(t.id);
              }}
              type="button"
              title={t.label}
              className={classnames('btn btn-default', {
                active: selectedTypes && selectedTypes.includes(t.id),
              })}
            >
              {t.label}
            </button>
          ))}
      </div>
    );
  }
}

CrmTypeButtonGroup.propTypes = {
  intl: intlShape.isRequired,
  selectedTypes: PropTypes.arrayOf(PropTypes.number),
  hiddenTypes: PropTypes.arrayOf(PropTypes.number),
  onChange: PropTypes.func.isRequired,
};

CrmTypeButtonGroup.defaultProps = {
  selectedTypes: [],
  hiddenTypes: [],
};

export default injectIntl(CrmTypeButtonGroup);
